import { render } from "./TemplatePreviewPanel.vue?vue&type=template&id=5e4b9b83&scoped=true"
import script from "./TemplatePreviewPanel.vue?vue&type=script&lang=js"
export * from "./TemplatePreviewPanel.vue?vue&type=script&lang=js"

import "./TemplatePreviewPanel.vue?vue&type=style&index=0&id=5e4b9b83&lang=scss&scoped=true"
import "./TemplatePreviewPanel.vue?vue&type=style&index=1&id=5e4b9b83&lang=scss"
script.render = render
script.__scopeId = "data-v-5e4b9b83"

export default script